import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b26b6d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = { class: "color-red" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "currency pr-1" }, "₹", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-5" }, "Plan validity", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "color-blue" }, "/Month", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-5" }, "Data", -1))
const _hoisted_7 = { class: "color-blue" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-5" }, "Speed", -1))
const _hoisted_9 = { class: "color-blue" }
const _hoisted_10 = { class: "plan-details-card-content d-flex mt-5 mx-6 text-center pb-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_jt_book_now_button = _resolveComponent("jt-book-now-button")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.plans, (plan, i) => {
      return (_openBlock(), _createBlock(_component_v_card, {
        key: i,
        class: "card-plan-small mt-6 pt-6 pl-10 pb-2 mx-6 mx-md-16"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "3"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("b", null, _toDisplayString(plan.planname), 1),
                  _createElementVNode("h2", _hoisted_2, [
                    _hoisted_3,
                    _createTextVNode(_toDisplayString(plan.price), 1)
                  ])
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "2"
              }, {
                default: _withCtx(() => [
                  _hoisted_4,
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "2"
              }, {
                default: _withCtx(() => [
                  _hoisted_6,
                  _createElementVNode("h3", _hoisted_7, _toDisplayString(plan.data), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "2"
              }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _createElementVNode("h3", _hoisted_9, _toDisplayString(plan.monthly) + " Mbps", 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "3"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_jt_book_now_button, {
                      onGetBookNowStatus: $setup.getBookNowStatus,
                      item: plan
                    }, null, 8, ["onGetBookNowStatus", "item"])
                  ])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1024))
    }), 128))
  ]))
}